var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-header',[_c('el-link',{staticClass:"company",attrs:{"underline":false,"href":"/"}},[_vm._v("\n    "+_vm._s(_vm.$t('APP.COMPANY'))+"\n  ")]),_c('div',{staticClass:"space"}),_c('app-offline'),_c('app-connected-user')],1)}
var staticRenderFns = []

export { render, staticRenderFns }